export default __webpack_public_path__ + "static/media/litho-landing-page-img-06.92b3ad92.jpg";